import { ActionButton } from '@eastcoal/common/components/Button/ActionButton'
import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '../../enums/FormMode'
import { SubmitType } from '../../enums/SubmitType'
import { useCrudFormStore } from '../../Store/hooks/useStore'

import { SaveButtonProps } from './interface'

export const SaveButton = ({
  icon,
  type = 'primary',
  children = '保存',
  ...restProps
}: SaveButtonProps) => {
  const { mode, submitLoading, submit } = useCrudFormStore(state =>
    pick(state, ['mode', 'submitLoading', 'submit'])
  )

  const handleSave = () => {
    submit({ submitType: SubmitType.SAVE })
  }

  return mode === FormMode.READ ? null : (
    <ActionButton
      ghost
      htmlType='submit'
      icon={icon}
      loading={submitLoading}
      type={type}
      onClick={handleSave}
      {...restProps}
    >
      {children}
    </ActionButton>
  )
}
